<template>
  <div
    id="prices"
    class="price-section d-flex flex-column pb-10 ga-6"
  >
    <PriceHeader
      :class="{ 'my-n3': isSpecialistsOnly }"
      :lpu="context.lpu"
      :town-name="context.town.name"
      :currency-abbreviation="context.currency.symbol"
      :hide-title-and-phone="isSpecialistsOnly"
      :appointment-phone="appointmentPhone"
      :price-range="context.price_range"
      :price-range-doctors="context.price_range_doctors"
      :price-range-mrt="context.price_range_mrt"
      :price-range-kt="context.price_range_kt"
      :price-range-uzi="context.price_range_uzi"
      :price-range-rentgen="context.price_range_rentgen"
      :price-range-uslugi="context.price_range_uslugi"
    />
    <template v-if="hasMedflexApi">
      <div class="d-flex flex-column ga-3">
        <PriceSearch
          :items="serviceCategories"
          @search:text="searchByText"
          @search:class="searchByClass"
          @search:default="resetSearch"
        />
        <PriceOnlineSwitch
          v-if="hasOnlineSwitch"
          :value="isOnlineOnly"
          @input="setOnlineOnly"
        />
        <PriceUpdateDate :data="context.unloaded_price_list_data" />
      </div>
    </template>
    <PriceUpdateDate
      v-else
      :data="context.unloaded_price_list_data"
    />
    <div
      v-if="!isSpecialistsOnly"
      class="price-section__loader my-n3"
      data-qa="lpu_page_price_loading"
    >
      <v-progress-linear
        v-show="isLoading"
        indeterminate
        height="2"
        color="var(--lpu-branding-color-primary)"
        class="price-section__loader-bar"
      />
    </div>
    <PriceCatalog
      :has-medflex-ui="hasMedflexUi"
      :has-medflex-api="hasMedflexApi"
      :show-pagination="showPagination"
      :show-all-button="showAllButton"
      :is-not-found="isNotFound"
      :is-enabled-direct="Boolean(context.lpu.appointment_service_direct)"
      :hide-group-titles="hideGroupTitles"
      :service-classes="displayClasses"
      :specialities="specialities"
      :categories="categories"
      :lpu="context.lpu"
      :lpu-id="context.lpu.id"
      :town-translit="context.lpu.town.translit"
      :town-timedelta="townTimedelta"
      :empty-src="emptySrc"
      :current-page="currentPage"
      :page-count="pageCount"
      @show-all="showAllServices"
      @page-input="relocatePage"
    />
  </div>
</template>

<script lang="ts" setup>
import usePriceSection from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/composables/usePriceSection'
import PriceHeader from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/PriceHeader.vue'
import PriceOnlineSwitch from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceOnlineSwitch.vue'
import PriceUpdateDate from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceUpdateDate.vue'
import PriceSearch from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceSearch.vue'
import PriceCatalog from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/PriceCatalog.vue'

const {
  context,
  appointmentPhone,
  serviceCategories,
  pageCount,
  currentPage,
  isNotFound,
  isLoading,
  isOnlineOnly,
  hasOnlineSwitch,
  showPagination,
  showAllButton,
  searchByText,
  searchByClass,
  resetSearch,
  relocatePage,
  setOnlineOnly,
  showAllServices,
  specialities,
  categories,
  hasMedflexApi,
  displayClasses,
  hasMedflexUi,
  isSpecialistsOnly,
  hideGroupTitles,
  emptySrc,
  townTimedelta,
} = usePriceSection()
</script>

<style scoped lang="scss">
.price-section {
  // min-w-0 в проекте нет как utility — только через CSS.
  // Иначе DayTabs/Swiper раздувает flex-ряд за container.
  min-width: 0;
  max-width: 100%;
}

.price-section__loader {
  height: 2px;
}

.price-section__loader-bar {
  ::v-deep .v-progress-linear__indeterminate {
    .long,
    .short {
      background-color: var(--lpu-branding-color-primary) !important;
    }
  }
}
</style>
